import React, { useState, TextareaHTMLAttributes, CSSProperties } from 'react';

export type TextareaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'style'> & {
  mono?: boolean;
  style?: CSSProperties;
};

export function Textarea({
  value,
  onChange,
  placeholder,
  rows = 4,
  mono,
  style,
  ...rest
}: TextareaProps) {
  const [focus, setFocus] = useState(false);

  return (
    <textarea
      rows={rows}
      value={value}
      onChange={onChange}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      placeholder={placeholder}
      style={{
        width: '100%', resize: 'vertical',
        padding: '12px 14px',
        borderRadius: 'var(--r-md)',
        background: 'var(--bg-surface)',
        color: 'var(--fg-primary)',
        border: `1px solid ${focus ? 'var(--accent)' : 'var(--line-border)'}`,
        boxShadow: 'none',
        fontSize: 16, lineHeight: '22px',
        fontFamily: mono ? 'var(--font-mono)' : 'var(--font-sans)',
        outline: 0,
        transition: 'box-shadow var(--dur-fast) var(--ease-out), border-color var(--dur-fast) var(--ease-out)',
        ...style,
      }}
      {...rest}
    />
  );
}

export default Textarea;
